import { render, staticRenderFns } from "./BillTotalsComponent.vue?vue&type=template&id=4d48b688&"
import script from "./BillTotalsComponent.vue?vue&type=script&lang=js&"
export * from "./BillTotalsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports